import { Link } from "@inertiajs/react";
import { useEffect, useState } from "react";

type PairWithADifferentCoachData = {
    showFreeTrialOnSwitchOption: boolean;
    numOfDaysUserOnTrial: number | null;
};

export default function PairWithADifferentCoachButton() {
    const [data, setData] = useState<PairWithADifferentCoachData | null>(null);

    const loadData = async () => {
        setData(
            (
                await window.axios.get<PairWithADifferentCoachData>(
                    route("client.coachInfo.getPairWithADifferentCoachData"),
                )
            ).data,
        );
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="mt-4">
            <Link
                href={route("switch-preferences.show")}
                className="text-brand-red underline"
            >
                Pair me with a different coach
            </Link>
            {data &&
                data.showFreeTrialOnSwitchOption &&
                data.numOfDaysUserOnTrial !== null && (
                    <p className="text-sm text-brand-gray">
                        {data.numOfDaysUserOnTrial > 1
                            ? "Your 1 week trial will restart with your new coach, no additional charge"
                            : "You have 1 week left on your trial"}
                    </p>
                )}
        </div>
    );
}
